module.exports = __webpack_public_path__ + "img/lotto-machine.b5b2ea37.png";